import { Theme } from '@mui/material/styles';

export default function IconButton({ palette }: Theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderColor: palette.common.black,
          borderRadius: '4px',
          color: palette.common.white,
          '&.Mui-disabled': {
            color: palette.grey[500]
          },
          '&:hover, &.active': {
            color: palette.common.white,
            opacity: 1,
            backgroundColor: 'rgba(256,256,256, .2)'
          }
        },
        '& .MuiTouchRipple-child': {
          borderRadius: '4px'
        },
        '& .MuiTouchRipple-rippleVisible': {
          borderRadius: '4px'
        }
      },
      sizeLarge: {
        width: 40,
        height: 40
      },
      sizeMedium: {
        width: 40,
        height: 40
      },
      sizeSmall: {
        width: 25,
        height: 25
      }
    }
  };
}
